<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Σύμβουλοι - Πωλητές</h4>
          <CButton color="primary" class="btn m-3 btn-primary" @click="createConsultant()">Προσθήκη συμβούλου - πωλητή</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            :items="items"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            sorter
          >
          <template #afm="{item}">
            <td>
              {{ getAfmText(item.afm) }}
            </td>
          </template>
          <template #profession="{item}">
            <td>
              {{ getProfessionText(item.profession) }}
            </td>
          </template>
           <template #show="{item}">
            <td>
              <CButton color="primary" @click="showConsultant( item.id )">Προβολή</CButton>
            </td>
          </template>
          <template #edit="{item}">
            <td>
              <CButton color="primary" @click="editConsultant( item.id )">Επεξεργασία</CButton>
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton v-if="you!=item.id" color="danger" @click="deleteConsultant( item.id )">Διαγραφή</CButton>
            </td>
          </template> -->
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  { 
    key: 'name', 
    label: 'Ονοματεπώνυμο'
  },
  {
    key: 'afm', 
    label: 'ΑΦΜ', 
    sorter: true, 
    filter: true
  },
  { 
    key: 'profession', 
    label: 'Επάγγελμα'
  },
  { 
    key: 'activity', 
    label: 'Δραστηριότητα'
  },
  { 
    key: 'show', 
    label: '', 
    sorter: false, 
    filter: false
  },
  { 
    key: 'edit', 
    label: '', 
    sorter: false, 
    filter: false
  },
  // { 
  //   key: 'delete', 
  //   label: '', 
  //   sorter: false, 
  //   filter: false
  // }
]

export default {
  name: 'ConsultantSellers',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      alertIsShown: false,
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    getAfmText (afm) {
      if (!afm) {
        return '-';
      } else {
        return afm;
      }
    },
    getProfessionText (profession) {
      if (!profession) {
        return '-';
      } else {
        return profession;
      }
    },
    consultantSellerLink (id) {
      return `consultantSellers/${id.toString()}`
    },
    editLink (id) {
      return `consultantSellers/${id.toString()}/edit`
    },
    showConsultant ( id ) {
      const consultantSellerLink = this.consultantSellerLink( id );
      this.$router.push({path: consultantSellerLink});
    },
    editConsultant ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    // deleteConsultant ( id ) {
    //   let self = this;
    //   let consultantSellerId = id;
    //   axios.post('/api/consultantSellers/' + id + '?token=' + localStorage.getItem("api_token"), {
    //     _method: 'DELETE'
    //   })
    //   .then(function (response) {
    //       self.message = 'Επιτυχής διαγραφή συμβούλου.';
    //       self.showAlert();
    //       self.getConsultants();
    //   }).catch(function (error) {
    //     console.log(error);
    //     self.$router.push({ path: '/login' });
    //   });
    // },
    createConsultant () {
      this.$router.push({path: 'consultantSellers/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getConsultants (){
      let self = this;
      axios.get('/api/consultantSellers?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.consultantSellers;
        self.you = response.data.you;
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    this.getConsultants();
  }
}
</script>
